export default __webpack_public_path__ + "static/media/original_collection_masculine_clive_christian.c2156691.jpg";